import styled from 'styled-components';

export const GroupsContainer = styled.div`
  overflow-y: auto;
  min-height: 0;
`;

export const FooterContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
`;
